import { loadStripe } from '@stripe/stripe-js';
import DisclosureFooter from '~/components/members-area/DisclosureFooter.vue';
export default {
  components: {
    DisclosureFooter
  },
  props: {},
  data() {
    return {
      isLoading: false,
      initialized: false,
      clientSecret: null,
      stripeElements: null,
      cardElement: null,
      validationError: null,
      $stripe: null // replacing plugin
    };
  },
  watch: {
    isLoading: {
      immediate: true,
      handler(val) {
        this.$emit('loading', val);
      }
    },
    clientSecret(val) {
      this.toggleIsLoading(true);
      const appearance = {
        // theme: 'night',
        // variables: {
        // 	borderRadius: '8px',
        // 	colorBackground: '#0A2540',
        // 	colorPrimary: '#ffffff',
        // 	accessibleColorOnColorPrimary: '#1A1B25',
        // 	colorText: 'white',
        // 	colorTextSecondary: 'white',
        // 	colorTextPlaceholder: '#ABB2BF',
        // 	tabIconColor: 'white',
        // 	logoColor: 'dark'
        // },
        // rules: {
        // 	'.Input': {
        // 		backgroundColor: '#0A2540',
        // 		border: '1px solid var(--colorPrimary)'
        // 	}
        // },
        theme: 'stripe',
        variables: {
          fontFamily: 'Acumin Pro, sans-serif',
          fontWeightNormal: '500',
          fontLineHeight: '1.5',
          fontLetterSpacing: ' 0.15px'
        },
        rules: {
          '.Label': {
            color: '#ffffff',
            fontWeight: '500',
            letterSpacing: '0.15px'
          },
          '.Tab': {
            backgroundColor: '#ffffff',
            fontWeight: '500',
            letterSpacing: '0.15px'
          },
          '.Tab--selected': {
            backgroundColor: '#ffffff',
            fontWeight: '600',
            letterSpacing: '0.15px'
          },
          '.Input': {
            backgroundColor: '#ffffff',
            fontWeight: '500',
            letterSpacing: '0.15px'
          },
          '.Input:hover': {
            backgroundColor: '#e8e8e8'
          },
          '.Input:focus': {
            backgroundColor: '#e8e8e8'
          },
          '.Error': {
            fontWeight: '600'
          },
          '.TermsText': {
            color: '#bfbfbf'
          }
        }
      };
      const options = {
        terms: {
          card: 'never'
        }
      };
      this.stripeElements = this.$stripe.elements({
        clientSecret: val,
        appearance
      });
      this.cardElement = this.stripeElements.create('payment', options);
      this.cardElement.mount('#stripe-target');
      this.cardElement.on('ready', this.onStripeReady);
    }
  },
  created() {
    this.toggleIsLoading(true);
    this.loadStripe();
  },
  mounted() {
    this.loadSetupIntent();
  },
  beforeDestroy() {
    if (this.cardElement) {
      setTimeout(() => {
        this.cardElement.destroy();
      }, 1000);
    }
  },
  methods: {
    async loadStripe() {
      if (this.$stripe) return;
      this.$stripe = await loadStripe(this.$config.stripePublishableKey);
      this.initialized = true;
      this.onStripeLoad();
    },
    async onStripeLoad() {
      await this.loadSetupIntent();
      console.log('stripe plugin initialized');
    },
    async loadSetupIntent() {
      this.toggleIsLoading(true);
      if (!this.initialized) return;
      try {
        const {
          data
        } = await this.$axios.post(`/api/members/stripe/setup-intent`);
        this.clientSecret = data.client_secret;
        this.$analyticsHub.track('AltPay Stripe Loaded');
      } catch (err) {
        this.handleError(err);
        this.$analyticsHub.track('AltPay Stripe Load Error');
        console.error(err);
      } finally {
        this.toggleIsLoading(false);
      }
    },
    onStripeReady() {
      this.toggleIsLoading(false);
    },
    async onSubmit() {
      this.toggleIsLoading(true);
      this.validationError = null;
      this.$analyticsHub.track('AltPay Card Submit Clicked');
      try {
        let error;
        ({
          error
        } = await this.stripeElements.submit());
        console.log('stripe validation', {
          error
        });
        if (!error) {
          let results;
          ({
            error,
            ...results
          } = await this.$stripe.confirmSetup({
            elements: this.stripeElements,
            confirmParams: {
              return_url: window.location.href
            },
            redirect: 'if_required'
          }));
          console.log('stripe results', results);
          if (!error) {
            // await this.$axios.post(`/api/members/stripe/payment-method`, {
            // 	payment_method: typeof results.setupIntent === 'object' ? results.setupIntent.payment_method : null
            // })

            this.cardElement.clear();
            this.$analyticsHub.track('AltPay Card Submitted');
            this.$emit('submit');
            this.$emit('continue');
          }
        }
        if (error) {
          this.$analyticsHub.track('AltPay Stripe Card Error');
          this.validationError = error;
          console.error(error);
        }
      } catch (err) {
        this.handleError(err);
        this.$analyticsHub.track('AltPay Stripe Submit Error');
        console.error(err);
      } finally {
        this.toggleIsLoading(false);
      }
    },
    onSkip() {
      this.$analyticsHub.track('AltPay Skip Clicked');
      if (this.cardElement) {
        this.cardElement.clear();
      }
      this.$emit('skip');
      this.$emit('continue');
    },
    toggleIsLoading(bool) {
      this.isLoading = bool;
    },
    handleError(error) {
      var _this$memberProfile;
      console.error(`[stripe] [error] mid#${(_this$memberProfile = this.memberProfile) === null || _this$memberProfile === void 0 ? void 0 : _this$memberProfile.id}`, error);
      this.$emit('error', error);
    }
  }
};